import { useState } from 'react';
import { previewAndDownloadCSV } from '../service/previewAndDownloadCSV';

const usePreviewAndDownloadCSV = (): [
  boolean | undefined,
  (
    accessToken: string | undefined,
    taskExecutionId: string,
  ) => Promise<{ validCsv: boolean } | undefined>,
  boolean,
] => {
  const [loading, setLoading] = useState<boolean>(false);
  const [validCsv, isValidCsv] = useState<boolean>(true);

  const downloadCSV = async (
    accessToken: string | undefined,
    taskExecutionId: string,
  ) => {
    setLoading(true);
    const templateData = await previewAndDownloadCSV(
      accessToken!,
      taskExecutionId,
    );
    if (typeof templateData === 'number') {
      setLoading(false);
      isValidCsv(false);
      return;
    }
    const blob = new Blob([templateData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'receipants.csv');
    document.body.appendChild(link);
    link.click();
    link.remove();

    setLoading(false);
    isValidCsv(true);
    return { validCsv };
  };

  return [loading, downloadCSV, validCsv];
};

export default usePreviewAndDownloadCSV;
